export enum ActivityTypes {
    Steps = 'Steps',
    ActiveMinutes = 'ActiveMinutes',
    MindfulMinutes = 'MindfulMinutes',
    ActivityMinutes = 'ActivityMinutes',
    Sleep = 'Sleep',
    ManuallyEnteredDurationActivity = 'ManuallyEnteredDurationActivity'
}
